// extracted by mini-css-extract-plugin
export default {"card":"C4-z"};